module.exports = __webpack_public_path__ + "img/cat_asian.de229e0f.jpg";